
import React from 'react';
import { Table, Column, Cell, ColumnGroup } from 'fixed-data-table-2';
import Row from '../basic/row';
import Col from '../basic/col';
import MCell from './MCell';
import SvgIcon from 'SvgIcon';
import { getPredicateValue, getRoundValue, getMultiplication } from '../../helpers/util'

export default class TableTouch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      pagination: { total: 0, current: 0, pageSize: 0 },
      subtotalData: {},
      sumData: [], // 合计数据
    };
    // showCheckBox 是否显示选择框  showRowNo 是否显示行号
    //是否单选 isPagination 是否分页
    this.GridProps = {
      showRowNo: true,
      showCheckBox: false,
      isPagination: false,
      showAggregates: true,
      showSubtotal: false,
      isRadio: true
    };
    this.dataList = [];/*grid数据*/
    this.columns = {};/*grid栏目数据*/
    this.ColIndexs = {};/*key与number对照*/
    this.headerHeight = 40;
    this.rowheight = props.rowHeight || 40;
    this.showRows = 0;
    this.showTotal = true
  }

  componentDidMount() {
    if (this.props.model) {
      this.props.model.addListener(this);
      /*表格高度*/
      let height = this.props.height ? this.props.height : 1020;
      let bodyHeight = height - this.headerHeight;
      // let pageIndex = Math.ceil(bodyHeight / this.rowheight / 10);
      this.showRows = Math.ceil(bodyHeight / this.rowheight);
      // let pageSize = pageIndex * 10;
      // this.props.model.setPageSize(pageSize);
    }
    this.setTable2DSum();
  }
  componentDidUpdate() {
    if (this.props.model)
      this.props.model.addListener(this);
  }
  componentWillUnmount() {
    if (this.props.model)
      this.props.model.removeListener(this);
  }

  setTable2DSum () {
    const model = this.props.model;
    const sumData = model && model.getCache('table2DSum');
    if (sumData && _.isEqual(sumData, this.state.sumData) == false) {
      this.setState({
        sumData
      })
    }
  }

  setSum = (sumData) => {
    // if (sumData.length > 0)
    this.setState({
      sumData
    })
  }

  componentWillUpdate () {
    this.setTable2DSum();
  }

  /* 小计 */
  calcSubTotalData = (columns, data) => {
    if (!data || data.length == 0) return;
    const subtotalData = {};
    for (const key in columns) {
      if (columns[key].bNeedSum) {
        // 交叉表的 指标项不支持小计
        if (this.props.model.t2DInfo_Bus_IsShow2D() && columns[key].t2DColType && !columns[key].t2DColType.includes('crossItem')) {
          subtotalData[key] = null
          continue
        }
        let sum = 0;
        data && data.map(row => {
          const val = row[key] ? row[key] : 0;
          sum = getMultiplication(sum, parseFloat(val), 'add');
        });
        subtotalData[key] = cb.utils.getRoundValue(sum, this._getSubINumPoint(columns[key]))
      }
    }
    // if (this.props.model) {
    //   this.props.model.execute('beforeCalcSubTotalData', { data, subtotalData });
    // }
    this.setState({ subtotalData });
    // if (this.props.model)
    //   this.props.model.execute('afterCalcSubTotal', subtotalData);
  }



  //-----------------------------------------------------------设置grid中columns，datasource等属性--------------------------------------------------------------------------------------------------
  setListenerState = (params) => {
    if (params.columnMode === 'local' && this.props.columns) {
      for (var attr in this.props.columns)
        Object.assign(this.props.columns[attr], params.columns[attr]);
      params.columns = this.props.columns;
    }
    let tmp_ColIndexs = {};
    let index = 0;
    /*cellState*/
    if (params.cellState)
      this.cellState = params.cellState;

    //栏目col与index对照
    var hasColumn = false;
    let tableWidth = this.props.width || 1100;
    for (var attr in params.columns) {
      if (this.props.widthMode == 'percent') {
        let iColWidth = parseFloat(params.columns[attr].iColWidth);
        let width = isNaN(iColWidth) ? 25 : iColWidth;
        width = tableWidth * width / 100;
        params.columns[attr].iColWidth = width;
      } else {
        if (isNaN(params.columns[attr].iColWidth)) {
          params.columns[attr].iColWidth = 200;
        } else {
          params.columns[attr].iColWidth = parseFloat(params.columns[attr].iColWidth * 3 / 4);
        }
      }
      hasColumn = true;
      if (index === 0)
        tmp_ColIndexs[attr] = 0;
      else
        tmp_ColIndexs[attr] = index;
      index = index + 1;
    }
    if (params.pageInfo) this.setPageInfo(params.pageInfo);
    this.GridProps.showRowNo = params.showRowNo;//是否显示行号
    this.GridProps.showCheckBox = params.showCheckBox;//是否显示复选框
    this.GridProps.isRadio = !params.multiple;//是否单选
    this.ColIndexs = tmp_ColIndexs;//栏目与index对照
    this.GridProps.showAggregates = params.showAggregates;// 是否显示合计
    this.GridProps.showSubtotal = params.showSubtotal;// 是否显示小计
    if (hasColumn) {
      this.columns = params.columns;
      if (params.rows && params.rows.length > 0) {
        this.dataList = params.rows;
        this.calcSubTotalData(params.columns, this.dataList);
      } else {
        this.dataList = [];
        this.calcSubTotalData(params.columns, this.dataList);
      }
      //初始化单元格状态
      this._InitCellStatus(params.columns, params.rows);
      let columnset = this.RemodelingColumn(params.rows, params.columns);
      this.setState({ columnset });
    }
  }

  //初始化单元格状态
  _InitCellStatus = (Columns, DataSource) => {
    if (DataSource !== undefined) {
      //设置初始单元格编辑状态/行选择初始状态/action状态/单元格状态 disabled/readOnly/style
      let temp_cellState = cb.utils.extend(true, [], this.cellState);
      let length = DataSource.length;
      if (length <= 0) return;
      for (let i = 0; i < length; i++) {
        DataSource[i]._selected = false;
        if (!temp_cellState[i])
          temp_cellState[i] = {};
        for (var attr in Columns) {
          if (!temp_cellState[i][attr])
            temp_cellState[i][attr] = { disabled: false, visible: false, readOnly: false, style: {} };
        }
      }
      this.cellState = temp_cellState;
    }
  }
  //----------------------------------------------接受viewmodeld参数-----------------------------------------------------------------------------------------------
  //接受来自model的column信息
  setColumns = (columns) => {
    let columndata = cb.utils.extend(true, {}, columns)
    for (var attr in columndata) {
      if (isNaN(columndata[attr].iColWidth))
        columndata[attr].iColWidth = 200;
      else
        columndata[attr].iColWidth = parseFloat(columndata[attr].iColWidth * 3 / 4);
    }

    let columnset = this.RemodelingColumn(this.dataList, columndata);
    this.columns = columndata;
    let length = this.dataList.length;
    for (let i = 0; i < length; i++) {
      for (var attr in columndata) {
        if (!this.cellState[i][attr]) {
          this.cellState[i][attr] = { disabled: false, visible: false, readOnly: false, style: {} };
        }
      }
    }
    this.setState({ columnset });
    /* 页面加载计算小计 */
    this.calcSubTotalData(this.columns, this.dataList);
  }
  //接收来自model的data信息
  setDataSource = (data) => {
    this.dataList = data;
    //初始化单元格状态
    this._InitCellStatus(this.columns, data);
    let columnset = this.RemodelingColumn(data, this.columns);
    this.setState({ columnset });
    /* 重算小计 */
    this.calcSubTotalData(this.columns, this.dataList);
  }

  //---------------------------------------------组织grid结构----------------------------------------------------------------------------------------------------------------
  //组织column结构
  RemodelingColumn = (dataList, columnState) => {
    let ret = [], columnData = [];
    let isGroup = false;/*是否多表头*/
    for (var attr in columnState) {
      if (columnState[attr].parent) {
        isGroup = true;
        break;
      }
    }
    this.isGroup = isGroup;
    /*行号*/
    if (this.GridProps.showRowNo) {
      if (!columnState.GridRowNo)
        columnState.GridRowNo = { 'cItemName': 'GridRowNo', 'iColWidth': 50, 'cControlType': 'Input', 'bFixed': '1' };
      columnData.push(columnState.GridRowNo);
    }
    for (var attr in columnState) {
      if (attr != 'GridRowNo') columnData.push(columnState[attr]);
    }
    if (isGroup ) 
      return this.RemodelingGroupColumn(dataList, columnState);
    columnData.map(function (col) {
      let column = this.setColumn(col.cItemName, col);
      ret.push(column);
    }, this);
    return ret;
  }

  /*多表头*/
  RemodelingGroupColumn = (dataList, columnState) => {

    /*行号*/
    // columnState.GridRowNo = { 'cFieldName': 'GridRowNo', 'cItemName': 'GridRowNo', 'iColWidth': 30, 'cControlType': 'Input' };

    let cols = {};
    let columns = cb.utils.extend(true, {}, columnState);
    this.totalWidth = 0;
    for (var key in columns) {
      let item = columns[key];//栏目属性对象
      item.iColWidth = item.iColWidth ? parseFloat(item.iColWidth) : 200;
      if (!item.parent) {
        cols[item.cItemName] = item;
      } else {
        this.loopColumn(item.parent, cols, item);
      }
      this.totalWidth += item.iColWidth;
    }
    return this.restructureColumn(dataList, cols);
  }
  /*组织多表头栏目*/
  restructureColumn = (dataList, columns) => {
    let col = [];
    for (var key in columns) {
      let item = columns[key];//栏目属性对象
      if (item.children) {
        let children = this.loopChildren(item);
        let header = this.getGroupHeader(item);
        col.push(
          <ColumnGroup key={item.cFieldName} header={header}>
            {children}
          </ColumnGroup>
        );
      } else {
        let column = this.setColumn(item.cItemName, item);
        let fixed = false;
        if (item.cItemName == 'CheckBox' || item.cItemName == 'GridRowNo') fixed = true;
        col.push(
          <ColumnGroup fixed={fixed} key={item.cFieldName} header={<Cell><div className='headerName' style={{ "height": this.headerHeight }}></div></Cell>}>
            {column}
          </ColumnGroup>
        )
      }
    }
    return col;
  }
  /*组织多表头显示组件*/
  getGroupHeader = (item) => {
    let header = [];
    header.push(
      <Row className="group-row" style={{ "height": (this.headerHeight || 40) }}>
        <div className="group-col" style={{ "height": (this.headerHeight || 40) }}><span>{item.cShowCaption}</span></div>
      </Row>
    )
    let headerRow = this.getHeaderRow(item.children);
    if (headerRow.length > 0) {
      let i = 1;
      headerRow.map(row => {
        header.push(
          <Row className="group-row" style={{ "height": (this.headerHeight || 40) }}>{row}</Row>
        )
        i += 1;
      });
      this.groupHeaderHeight = i * (this.headerHeight || 40);
    } else {
      this.groupHeaderHeight = (this.headerHeight || 40);
    }
    let rowWidth = this.getGroupHeaderWidth(item.children);
    return <div className="table-group-header" style={{ "width": rowWidth }}>{header}</div>
  }
  /*组织多表头的行表头*/
  getHeaderRow = (children) => {
    let headerRows = [], headerRow = [];
    children.map(col => {
      if (col.children) {
        var width = this.getGroupHeaderWidth(col.children);
        col.iColWidth = width;
        headerRow.push(
          <div className="group-col" style={{ "height": (this.headerHeight || 40), "width": width }}><span>{col.cShowCaption}</span></div>
        )
        if (col.children[0].children) {
          let newRow = this.getHeaderRow(col.children);
          headerRows[headerRows.length] = newRow;
        }
      }
    });
    if (headerRow.length > 0)
      headerRows[headerRows.length] = headerRow;
    return headerRows;
  }
  /*获取多表头宽度*/
  getGroupHeaderWidth = (item) => {
    var width = 0;
    item.map(col => {
      let w = this.loopHeader(col, width);
      width += w;
    });
    return width;
  }
  loopHeader = (item) => {
    let children = item.children;
    let width = 0;
    if (children) {
      children.map(col => {
        if (col.iColWidth) {
          width += col.iColWidth;
        } else {
          width += this.loopHeader(col);
        }
      });
    } else {
      width = item.iColWidth ? item.iColWidth : 200;
    }
    return width;
  }
  loopChildren = (item) => {
    let col = [];
    item.children.forEach(function (ele) {
      if (ele.children) {
        let children = this.loopChildren(ele);
        col = col.concat(children);
      } else {
        let column = this.setColumn(ele.cItemName, ele);
        col.push(column)
      }
    }, this);

    return col;
  }
  loopColumn = (data, cols, item, child) => {
    if (!data.parent) {
      if (!cols[data.cFieldName]) {
        cols[data.cFieldName] = data;
        cols[data.cFieldName].children = [];
      }
      if (child && child.parent) delete child.parent;
      let colsChild = cols[data.cFieldName].children;
      let existChild = false, existIndex = 0;
      colsChild.forEach(function (ele, index) {
        if (ele.cFieldName == item.cFieldName) {
          existIndex = index;
          existChild = true;
        }
      }, this);

      if (existChild) {
        cols[data.cFieldName].children[existIndex].children.push(child);
      } else {
        if (child) {
          item.children = [child];
        }
        if (item.parent) delete item.parent;
        cols[data.cFieldName].children.push(item);
      }
    } else {
      this.loopColumn(data.parent, cols, data, item);
    }
  }

  //设置column
  setColumn = (attr, col) => {
    var iColWidth = parseFloat(col.iColWidth);
    let width = isNaN(iColWidth) ? 200 : iColWidth;
    let headerCell, headerClassName = '';
    let fiexd = col.bFixed == 1 ? true : false;
    let align = 'left';
    // if (col.iAlign === 1)
    //   align = 'left';
    // else if (col.iAlign === 2)
    //   align = 'center';
    // else
    //   align = 'right';

    headerCell = (
      <Cell className='mobile-header-cell'>
        {/* <div style={{ textAlign: align, width: this.props.width, display: "flex" }} id={col.index}> */}
        <div style={{ "width": width }} id={col.index}>
          <span style={{ width: width }} className="textCol table-header-name">
            {col.cShowCaption}
          </span>
        </div>
      </Cell>
    )
    return (<Column key={attr}
      allowCellsRecycling columnKey={attr}
      header={headerCell} cell={(rowIndex) => this.setCell(rowIndex, col)}
      width={width} align={align} fixed={fiexd} footer={this._setFooter}/>);
  }

  // 获取小计的小数位数
  _getSubINumPoint = (col) => {
    // 获取基本iNum
    let NumPoint = col.iNumPoint;
    let cFormatData = col.cFormatData;
    // 优化
    if (!cb.utils.isEmpty(cFormatData)) {
      try {
        cFormatData = JSON.parse(cFormatData);
      } catch (e) {
        console.error('数量/金额/单价，预制错误！');
      }
      const relatedName = cFormatData.related;
      if (relatedName) {
        if (relatedName.startsWith('parentdata.')) {
          const parentField = relatedName.split('parentdata.')[1];
          NumPoint = this._getParentModel() && this._getParentModel().get(parentField) && this._getParentModel().get(parentField).getValue();
        } else {
          NumPoint = this.getSumData(relatedName, 'max');
        }
      }
    }
    // 默认2位小数
    return NumPoint || 2;
  }

  _setFooter = (cellProps) => {
    const { columnKey } = cellProps;
    const column = this.columns[columnKey] || {};
    const { bNeedSum, iAlign } = column;
    // showAggregates, showSubtotal, showCheckBox,
    const { showAggregates, showSubtotal, showCheckBox, showRowNo } = this.GridProps;
    // showSelRows
    const { subtotalData } = this.state;
    let footerTitle;
    const footerCellStyle = { padding: '0 8px', 'text-align': 'left', width: cellProps.width };
    const footerTitleStyle = { paddingLeft: '10px', height: this.props.footerHeigh || this.rowheight, backgroundColor: '#fdf3e1' }
    // if (iAlign == 2) footerCellStyle['text-align'] = 'center';
    // if (iAlign == 3) footerCellStyle['text-align'] = 'right';
    if (showAggregates == true && showSubtotal) { // 显示小计合计
      footerTitle = (
        <div className='fixedDataTable-footer-title'>
          <div className='public_fixedDataTableCell_cellContent subtotal subtotal_name' style={footerTitleStyle}> 小计</div>
          <div className='public_fixedDataTableCell_cellContent aggregates aggregates_name' style={footerTitleStyle}> 合计</div>
        </div>
      );
      // if (showCheckBox && this.props.tableTyep != 'rptTable') {
      // if (showCheckBox) {
      //   if (cellProps.columnKey === 'CheckBox') return footerTitle;
      // } else if (showRowNo) {
      //   if (cellProps.columnKey === 'GridRowNo') return footerTitle;
      // } else if (this.ColIndexs[cellProps.columnKey] === 0) {
      //   return footerTitle;
      // }
      if (showRowNo) {
        if (cellProps.columnKey === 'GridRowNo') return footerTitle;
      }
      if (bNeedSum) {
        let totalSum;
        const sumData = this.state.sumData;
        for (const key in sumData[0]) {
          if (key === cellProps.columnKey) {
            totalSum = sumData[0][key];
          }
        }
        let sum = this.props.model && this.getSumData(columnKey) || 0;
        if (subtotalData[cellProps.columnKey] === null) {
          sum = null
        } else if (!cb.utils.isEmpty(subtotalData[cellProps.columnKey])) {
          // 计算是和的情况下取值
          const cSumTyp = column && column.cSumType;
          if (!cSumTyp || cSumTyp == 'sum') {
            sum = subtotalData[cellProps.columnKey];
            sum = this._getDecimal(this.columns[cellProps.columnKey], sum);
          }
        }
        if (cb.utils.isEmpty(totalSum)) totalSum = 0;
        if (!this.state.openServerDecimal) {
          totalSum = this._getDecimal(column, totalSum, sumData[0]); // 合计直接使用后端传来的数据，前端不再进行精度处理
        }
        return (
          <div className='fixedDataTable-footer-title'>
            <div className='public_fixedDataTableCell_cellContent subtotal'>
              <Cell style={{ height: this.props.footerHeigh || this.rowheight, backgroundColor: '#fdf3e1' }}>
                <div style={footerCellStyle} className='textCol'>
                  {sum}
                </div>
              </Cell>
            </div>
            <div className='public_fixedDataTableCell_cellContent aggregates'>
              <Cell style={{ height: this.props.footerHeigh || this.rowheight, backgroundColor: '#fdf3e1' }}>
                <div style={footerCellStyle} className='textCol'>
                  {totalSum}
                </div>
              </Cell>
            </div>
          </div>
        )
      } else {
        return (
          <div className='fixedDataTable-footer-title'>
            <div className='public_fixedDataTableCell_cellContent subtotal' style={footerTitleStyle}>
              <Cell style={{ height: this.props.footerHeigh || this.rowheight }}>
                <div style={footerCellStyle} className='textCol' />
              </Cell>
            </div>
            <div className='public_fixedDataTableCell_cellContent aggregates' style={footerTitleStyle}>
              <Cell style={{ height: this.props.footerHeigh || this.rowheight }}>
                <div style={footerCellStyle} className='textCol' />
              </Cell>
            </div>
          </div>
        )
      }
    } else if (showAggregates == 'local') { // 显示小计 (showSelRows && showAggregates == true && showSubtotal)
      const isSubtotal = this._isSubtotal();
      footerTitle = (
        <div className='fixedDataTable-footer-title'>
          <div className='public_fixedDataTableCell_cellContent aggregates'>{isSubtotal ? ' 小计' : ' 合计'}</div>
        </div>
      );
      // if (showCheckBox && this.props.tableTyep != 'rptTable') {
      if (showCheckBox) {
        if (columnKey === 'CheckBox') return footerTitle;
      } else if (showRowNo) {
        if (columnKey === 'GridRowNo') return footerTitle;
      } else if (this.ColIndexs[columnKey] === 0) {
        return footerTitle;
      }
      if (bNeedSum) {
        let sum = this.props.model && this.getSumData(columnKey) || 0;
        if (subtotalData[cellProps.columnKey] === null) {
          sum = null
        } else if (!cb.utils.isEmpty(subtotalData[cellProps.columnKey])) {
          // 计算是和的情况下取值
          const cSumTyp = column && column.cSumType;
          if (!cSumTyp || cSumTyp == 'sum') {
            sum = subtotalData[cellProps.columnKey];
            sum = this._getDecimal(this.columns[cellProps.columnKey], sum);
          }
        }
        return (
          <Cell style={{ height: this.props.footerHeigh || this.rowheight }}>
            <div style={footerCellStyle} className='textCol'>
              {sum}
            </div>
          </Cell>
        )
      }
    } else if (showAggregates && !showSubtotal) { // 显示合计
      footerTitle = (
        <Cell style={{ height: this.props.footerHeigh || this.rowheight }}>
          <div style={footerCellStyle} className='textCol'>
            合计
          </div>
        </Cell>
      );
      
      if (cellProps.columnKey === "org_code") {
        this.showTotal = false
        return footerTitle
      }

      if (cellProps.columnKey === "store_code" && this.showTotal) {
        return footerTitle
      }

      // if (showCheckBox && this.props.tableTyep != 'rptTable') {
      if (showCheckBox) {
        if (cellProps.columnKey === 'CheckBox') return footerTitle;
      } else if (showRowNo) {
        if (cellProps.columnKey === 'GridRowNo') return footerTitle;
      } else if (this.ColIndexs[cellProps.columnKey] === 0) {
        return footerTitle;
      }
      if (bNeedSum) {
        let totalSum;
        const sumData = this.state.sumData;
        for (const key in sumData[0]) {
          if (key === cellProps.columnKey) {
            totalSum = sumData[0][key];
          }
        }
        if (cb.utils.isEmpty(totalSum)) totalSum = 0;
        if (!this.state.openServerDecimal) {
          totalSum = this._getDecimal(column, totalSum, sumData[0]); // 合计直接使用后端传来的数据，前端不再进行精度处理
        }
        return (
          <div className='fixedDataTable-footer-title'>
            <div className='public_fixedDataTableCell_cellContent aggregates'>
              <Cell style={{ height: this.props.footerHeigh || this.rowheight }}>
                <div style={footerCellStyle} className='textCol'>
                  {cb.utils.formatAmount(totalSum)}
                </div>
              </Cell>
            </div>
          </div>
        )
      }
    }
  }

  _getDecimal = (col, sum, sumData) => {
    let NumPoint = col.iNumPoint;
    /* 谓词变量支持系统参数 */
    let cFormatData = col.cFormatData;
    try {
      if (!cFormatData || cFormatData == '') {
        cFormatData = {};
      } else {
        cFormatData = JSON.parse(cFormatData);
      }
    } catch (e) {
      console.error('数量/金额/单价，预制错误！');
    }
    const relatedName = cFormatData.related;
    if (relatedName && !relatedName.startsWith('parentdata.')) {
      if (sumData && sumData[relatedName])
        NumPoint = sumData[relatedName];
      else
        NumPoint = this.getSumData(relatedName, 'max');
    }
    const decimal = cFormatData.decimal ? getPredicateValue(cFormatData.decimal) : null;
    const controlType = col.cControlType ? col.cControlType.trim().toLocaleLowerCase() : '';
    if (controlType === 'money') {
      cFormatData.splitter = true
      if (decimal)
        NumPoint = decimal;
      else
        NumPoint = cb.rest.AppContext.option && cb.rest.AppContext.option.amountofdecimal || 0;
    } else if (controlType === 'price') {
      if (decimal)
        NumPoint = decimal;
      else
        NumPoint = cb.rest.AppContext.option && cb.rest.AppContext.option.monovalentdecimal || 0;
    } else if (controlType === 'inputnumber' || controlType === 'numberwidget') {
      if (decimal)
        NumPoint = decimal;
      else if (!NumPoint || NumPoint == '') {
        const decimal = sum.toString().split('.')[1].length;
        NumPoint = decimal || 0;
      }
    } else {
      NumPoint = null;
    }
    if (controlType === 'money' || (cFormatData.decimal && cFormatData.decimal.indexOf('amountofdecimal'))) {
      cFormatData.splitter = true
    }
    sum = parseFloat(sum);
    if (!isNaN(NumPoint) && NumPoint != null) {
      /* add by jinzh1 tofixed函数  默认支持最大支持20  依环境改变而变 暂改成20 */
      if (NumPoint > 20) NumPoint = 20;
      sum = getRoundValue(sum, NumPoint);
    }
    // if (cFormatData.splitter) { // add 千分位
    //   sum = this.formatter(sum);
    // }

    // col.bEnableFormat = 1;
    // console.log(sum+" ==== ",col);
    sum = cb.getNumberFromat(sum, col.bEnableFormat, (sum) => {
      return this.formatter(sum);
    }, NumPoint, col);

    return sum;
  }

  /* 根据 合计方式 计算合计列值 */
  getSumData = (cItemName, defaultType) => {
    const column = this.props.model.getColumn(cItemName);
    if (!column) return 0;
    const data = _.compact(this.dataList) || [];
    let cSumType = column.cSumType;
    if (!cb.utils.isEmpty(defaultType) && (cb.utils.isEmpty(cSumType) || cSumType === 'support')) cSumType = defaultType;
    if (cb.utils.isEmpty(cSumType)) cSumType = 'sum';
    cSumType = cSumType.toLocaleLowerCase();
    let sumData = null;
    switch (cSumType) {
      case 'max':
        data.map(row => {
          const val = row[cItemName];
          if (cb.utils.isEmpty(sumData))
            sumData = cb.utils.isEmpty(val) ? 0 : val;
          if (val > sumData) sumData = val;
        });
        break;
      case 'min':
        data.map(row => {
          const val = row[cItemName];
          if (cb.utils.isEmpty(sumData))
            sumData = cb.utils.isEmpty(val) ? 0 : val;
          if (val < sumData) sumData = val;
        });
        break;
      case 'avg':
        data.map(row => {
          let val = row[cItemName];
          val = val || 0;
          sumData = sumData + parseFloat(val);
        });
        if (data.length > 0) sumData = sumData / data.length;
        break;
      case 'count':
        sumData = data.length;
        break;
      default:/* 其余全部按 sum处理 */
        if (cb.utils.isEmpty(sumData)) sumData = 0;
        data.map(row => {
          let val = row[cItemName];
          val = val || 0;
          sumData = getMultiplication(sumData, val, 'add');
        });
        break;
    }
    if (cb.utils.isEmpty(sumData)) sumData = 0;
    sumData = this._getDecimal(column, sumData);
    return sumData;
  }

  setCell = (rowIndex, col) => {
    return (<MCell
      dataList={this.dataList} readOnly={true} RowProperty={rowIndex}
      Column={col} model={this.props.model}
      columnsList={this.columns} rowHeight={this.rowheight}
    />);
  }
  //行单击事件
  _onRowClick = (e, index) => {
    if (this.dataList.length == 0 || !this.dataList[index]) return;
    if (!this.GridProps.showCheckBox || this.GridProps.isRadio || this.props.hasAction)
      this.props.model.select(index);
    this.props.model.setFocusedRowIndex(index);
  }
  //设置分页
  setPageInfo = (paginationlist) => {
    if (paginationlist.pageSize === -1)
      this.GridProps.isPagination = false;
    var pageinfo = this.state.pagination;
    pageinfo.total = paginationlist.recordCount
    pageinfo.current = paginationlist.pageIndex;
    pageinfo.pageSize = paginationlist.pageSize;
    this.setState({
      pagination: pageinfo
    });
  }
  _getDecimal = (col, sum) => {
    let NumPoint = col.iNumPoint;
    /*谓词变量支持系统参数*/
    let cFormatData = col.cFormatData;
    try {
      if (!cFormatData || cFormatData == '') {
        cFormatData = {};
      } else {
        cFormatData = JSON.parse(cFormatData);
      }
    } catch (e) {
      cb.utils.alert('数量/金额/单价，预制错误！', 'error');
    }
    let decimal = cFormatData.decimal ? getPredicateValue(cFormatData.decimal) : null;
    let controlType = col.cControlType ? col.cControlType.trim().toLocaleLowerCase() : '';
    if (controlType === 'money') {
      if (decimal)
        NumPoint = decimal;
      else
        NumPoint = cb.rest.AppContext.option.amountofdecimal;
    } else if (controlType === 'price') {
      if (decimal)
        NumPoint = decimal;
      else
        NumPoint = cb.rest.AppContext.option.monovalentdecimal;
    } else if (controlType === 'inputnumber') {
      if (decimal)
        NumPoint = decimal;
      else
        if (!NumPoint || NumPoint == '') NumPoint = 0;

    } else {
      NumPoint = null;
    }
    if (!isNaN(sum) && NumPoint) {
      sum = Number(sum);
      sum = sum.toFixed(NumPoint);
    }
    return sum;
  }
  onScrollEnd = (scrollx, scrolly, hideRows) => {
    let rowCount = this.dataList.length;
    let needLoad = false;
    if ((this.showRows + hideRows) == rowCount) needLoad = true;
    if (!needLoad && this.isGroup && (hideRows + this.showRows - rowCount) >= 0) needLoad = true;
    if (needLoad) this.loadMore();
  }
  loadMore = () => {
    let pagination = this.state.pagination;
    let newSize = pagination.current + 1;
    let pageCount = pagination.total / pagination.pageSize;
    pageCount = Math.ceil(pageCount);
    if (newSize > pageCount) return;
    if (this.props.model)
      this.props.model.setPageIndex(pagination.current + 1);
  }
  getEmptyData = () => {
    let data = this.dataList;
    if (data.length) return null;
    if (!this.state.showSearch)
      return (
        <div className='eChartMobile-nodata'>
          <SvgIcon type="huanxingtu" />
          <div className='eChartMobile-nodata-text' > 暂时没有数据哦~</div>
        </div>
      )
    else
      return <div className='refer_no_date'></div>
  }

  getFooterHeight = (empty) => {
    const { showAggregates, showSubtotal } = this.GridProps
    if (empty)
      return 0
    if (showAggregates == true && showSubtotal) {
      return this.props.footerHeight || (this.rowheight * 2)
    } else if (showAggregates == 'local' || (showAggregates && !showSubtotal)) {
      return this.props.footerHeight || this.rowheight
    }
  }

  render() {
    let emptyData = this.getEmptyData();
    const footerHeight = this.getFooterHeight(emptyData)
    return (
      <div className="mobile-grid">
        <Row>
          <Table
            rowHeight={this.rowheight}
            overflowY={'auto'}
            overflowX={'auto'}
            showScrollbarX={false}
            showScrollbarY={false}
            onScrollEnd={this.onScrollEnd}
            // onRowTouchEnd={this.onRowTouchEnd}
            footerHeight={footerHeight}
            headerHeight={this.headerHeight || 40}
            groupHeaderHeight={this.groupHeaderHeight || 0}
            rowsCount={this.dataList.length}
            width={this.props.width}
            height={this.props.height}
            isColumnResizing={false}
            onRowClick={this._onRowClick}
            touchScrollEnabled
          >
            {this.state.columnset}
          </Table>
          {emptyData}
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/grid-mobile/MTable.jsx